import * as React from "react";
var CardSectionContext = React.createContext({
  expandable: false,
  expanded: false,
  handleToggleSection: function handleToggleSection() {},
  onKeyDownHandler: function onKeyDownHandler() {}
});
export default CardSectionContext;